import "../style.css";

import Modal from "react-modal";
import React, {
  createRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import CloseIcon from "assets/icons/actions/close.svg?react";
import Store from "../ModalStore";
import ModalStore from "../ModalStore";
import { useLoggedIn } from "stores/auth/authStore";
import SaddleLogo from "assets/icons/saddleLogo.svg?react";

Modal.setAppElement("#root");

export const NotificationModal = forwardRef((props, ref) => {
  const { setIsAction } = useLoggedIn();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [wasOpened, setWasOpened] = React.useState(false);
  const [state] = React.useState({});
  const [onCloseOpenPrevious, setOnCloseOpenPrevious] = React.useState(false);
  const [uid, setUid] = useState();
  const [childrenVisible, setChildrenVisible] = useState(true);
  const {
    title,
    children,
    className,
    shouldCloseOnOverlayClick = true,
    showHeader = true,
  } = props;

  useEffect(() => {
    const handleRouteChange = () => {
      if (modalIsOpen) {
        closeModal();
      }
    };

    window.addEventListener("popstate", handleRouteChange);

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args);
      handleRouteChange();
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      handleRouteChange();
    };

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalIsOpen]);

  const forceUpdate = () => {
    setChildrenVisible(false);
    setChildrenVisible(true);
  };

  useImperativeHandle(
    ref,
    () => {
      return {
        uid: getUid(),
        title: title,
        isOpen: isOpen(),
        state: state,
        open() {
          ModalStore.closeAll(uid);
          setIsOpen(true);
          setWasOpened(true);
          ModalStore.setPreviousOpened(this);
        },
        close(withoutEvents = false) {
          setIsOpen(false);
          if (!withoutEvents) {
            props.onClose && props.onClose();
          }
        },
        toggle() {
          setIsOpen(!modalIsOpen);
        },
        changeProps(newProps) {
          ref.props = { ...ref.props, ...newProps };
          forceUpdate();
        },
        onCancel() {
          // setOnCancelHandler(() => cb);
        },
        onCloseOpenPrevious() {
          setOnCloseOpenPrevious(true);
        },
        rerender(c) {
          ModalStore.components
            .find((c) => c.ref.current.uid === this.uid)
            .remove();
          ModalStore.open(c());
        },
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modalIsOpen, wasOpened]
  );

  function isOpen() {
    return modalIsOpen;
  }

  function getUid() {
    let out;

    if (!uid) {
       
      out =
        "modal_" +
        Date.now().toString(36) +
        Math.random().toString(36).substr(2);
      setUid(out);

      return out;
    } else {
      return uid;
    }
  }

  function closeModal() {
    setIsOpen(false);
    setIsAction(null);
    props.onClose && props.onClose();
    if (onCloseOpenPrevious) {
      ModalStore.getPreviousOpened()?.open();
    }
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Modal"
      closeTimeoutMS={300}
      className={`notification-modal`}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      overlayClassName="notification-overlay"
    >
      <div className={`notification-content w-[500px]  ${className}`}>
        {showHeader && (
          <div className="bg-[#2b364b] w-[100%] rounded-tl-[12px] rounded-tr-[12px] p-[13px] flex items-center justify-between h-[51px] relative top-[-2px]">
            <SaddleLogo className="w-[149px] h-[51px]" />
            <CloseIcon className="cursor-pointer" onClick={closeModal} />
          </div>
        )}

        <div className="p-[40px]">
          <div className="notification-content__title">
            {title || children.title}
          </div>
          <div className="notification-content__body">
            <div className="notification-content-body">
              {childrenVisible &&
                (typeof children.content === "object" &&
                  !children.content?.render ? (
                  children.content
                ) : (
                  <children.content></children.content>
                ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
});

export const ReactModals = () => {
  const [state, setState] = useState([...Store.components]);
  const elRefs = React.useRef([]);

  Store.setUpdateHandler((components) => {
    setState(components);
  });

  return (
    <>
      {state.map((item, index) => {
        const Modal = item.component;

        elRefs.current[index] = elRefs.current[index] || createRef();
        item.ref = elRefs.current[index];

        if (typeof Modal === "object" && !Modal?.render) {
          return (
            <Modal.type
              {...Modal.props}
              key={index}
              ref={elRefs.current[index]}
            />
          );
        }

        return <Modal key={index} ref={elRefs.current[index]}></Modal>;
      })}
    </>
  );
};

export default NotificationModal;
